document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.modal .embed').forEach((elem) => {
    let modal = elem.closest('.modal');
    modal.addEventListener('hidden.bs.modal', (evt) => {
      evt.currentTarget.querySelector('.embed').innerHTML = '';
      evt.currentTarget.querySelector('.embed').innerHTML = evt.currentTarget.querySelector('.embed-cache').innerHTML
    })
  })

  document.querySelectorAll('.modal iframe').forEach((elem) => {
    let modal = elem.closest('.modal');
    modal.addEventListener('hidden.bs.modal', (evt) => {
      // resets the iframe on close
      evt.currentTarget.querySelector('iframe').src = evt.currentTarget.querySelector('iframe').src;
    });
  })
})
